export default {
    es: {
        Vallarta: {
            title: "Puerto Vallarta",
            text: " es un lugar turistico preferido en el mundo, para vacacionar, debido a sus asombrosos paisajes de selva tropical con playas con aguas cristalinas. Un actractivo es el Muelle de los muertos simbolo que representa la ciudad debido a su estructura, conoce este y más lugares naturales."
        },
        Zapopan: {
            title: "Sayulita ",
            text: "conocido por sus olas ideales para practicar surf, se ha convertido en un destino mundial que recibe millones del visitas al año. Cuenta con el mejor clima, además sus calles coloridas hacen de el un lugar fascinante para aquellos que busquen conocer un rincón lleno de arte y cultura."
        },
        Guadalajara: {
            title: "Bucerías ",
            text: "un tesoro de Riviera Nayarit, que nos asombra con la tranquila de sus playas, el color de sus viviendas y deleitarte con los sabores de su comida. Podrás encontrar."
        },
        Bucerias: {
            title: "Bucerías ",
            text: "un tesoro de Riviera Nayarit, que nos asombra con la tranquila de sus playas, el color de sus viviendas y deleitarte con los sabores de su comida. Podrás encontrar."
        },
        NuevoVallarta: {
            title: "Nuevo Vallarta ",
            text: "paraíso de la Riviera Nayarit donde el lujo se fusiona  con la naturaleza, dando resultado un lugar único el cual ofrece hoteles, resturantes, campos de Golf, lujosos condominios, entre otros complejos exclusivos.Su extensión de playas color azul turquesa permiten apreciar el oleaje del mar y disfrutar de un descanso y tranquilidad. "
        },
        Penita: {
            title: "La Peñita Jaltemba (Rincón de Guayabitos).",
            subtitle: "La Peñita de Jaltemba",
            text: "ubicada en Riviera Nayarit, un lugar lleno de vida,  rodeado de playas con asombrosos amaneceres, un paraíso preferido por los turístas.Al otro lado del arroyo Guinea, encontramos a Rincón de Guayabitos, conocido por su imensa bahía color transparente donde las familias disfrutan nadar y degustar los platillos típìcos de los lugareños. "
        },
        Sayulita: {
            title: "Sayulita",
            text: "conocido por sus olas ideales para practicar surf,  se ha convertido en un destino mundial que recibe millones del visitas al año. Cuenta con el mejor clima, además sus calles coloridas hacen de el un lugar fascinante para aquellos que busquen conocer un rincón lleno de arte y cultura. "
        },
        contact: {
            title: "¿Cómo llegar?",
            description: "Contamos con salidas todos los días desde Guadalajara, Zapopan y Tlaquepaque, adquiere tus boletos desde esta página web ó comunicate atención 24 horas a nuestro call center para cualquier duda o comentario. "
        }

    },
    en: {
        Vallarta: {
            title: "Puerto Vallarta",
            text: " is a beautiful place and a tourists favorite to go on vacation due to its beautiful rainforest and beaches with clear water. A very popular spot is “El muelle de los muertos”  because it represents the city due to its structure. Visit this wonderful place."
        },
        Zapopan: {
            title: "Sayulita ",
            text: "well known for its perfect waves to surf,  has become a world destiny that gets millions of visitors every year. On top of having the best weather, it also has the most colorful and beautiful streets. It is the perfect place to go if what you are looking for is culture and art."
        },
        Guadalajara: {
            title: "Bucerias",
            text: " is a treasure of “Riviera Nayarit” due to its beautiful calm beaches, colorful houses and  delicious food."
        },
        Bucerias: {
            title: "Bucerias",
            text: " is a treasure of “Riviera Nayarit” due to its beautiful calm beaches, colorful houses and  delicious food."
        },
        NuevoVallarta: {
            title: "Nuevo Vallarta ",
            text: " Riviera de nayarit´s paradise, where luxury merges with nature having as a result being the only place where you can find, hotels, restaurants, golf courses, luxury condos, among other exclusive resorts. Its beautiful turquoise blue beaches  allow you to enjoy an amazing view while relaxing on the beach ."
        },
        Penita: {
            title: "La Peñita Jaltemba (Rincón de Guayabitos).",
            subtitle: "La Peñita de Jaltemba",
            text: " is located at La riviera de nayarit, it is a place full of life, surrounded by amazing beaches and beautiful sunrises, it is a paradise prefered by many tourists. on the other side of guinea stream you will find “Rincon de guayabitos'' known for its huge beautiful bay with crystal clear water where families enjoy swimming and enjoying the typical food."
        },
        Sayulita: {
            title: "Sayulita ",
            text: "well known for its perfect waves to surf,  has become a world destiny that gets millions of visitors every year. On top of having the best weather, it also has the most colorful and beautiful streets. It is the perfect place to go if what you are looking for is culture and art."
        },
        contact: {
            title: "How to get there?",
            description: "We have departures every day from Guadalajara, Zapopan and Tlaquepaque. Purchase your tickets on our website or call our 24 / 7 call center to ask any questions you may have. "
        }
    }
}